import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, AppBar, Toolbar } from '@material-ui/core';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';

import Button from 'on_web/components/shared/Common/Button';
import { TRANSPARENT_WHITE } from 'colours';

import useCheckScreenSize from 'on_web/hooks/useCheckScreenSize';

const useStyles = makeStyles(theme => ({
  root: {
    top: 'auto',
    bottom: 0,
  },
  colorTransparent: {
    backgroundColor: TRANSPARENT_WHITE,
  },
}));

export default function StickyNavigation(props) {
  const classes = useStyles();
  const [isDesktop] = useCheckScreenSize();

  return (
    <React.Fragment>
      <AppBar position="fixed" color="transparent" classes={{ ...classes }}>
        <Toolbar>
          <Grid
            container
            direction="row"
            justify={isDesktop ? 'center' : 'space-between'}
            alignItems="center"
          >
            <Grid item style={{ marginRight: isDesktop ? '20px' : '0' }}>
              {props.hideBack !== true && props.editMode !== true && (
                <Button
                  startIcon={<NavigateBeforeIcon />}
                  variant="text"
                  onClick={props.onClickBack}
                >
                  {props.backButtonText ? props.backButtonText : <>Back</>}
                </Button>
              )}
            </Grid>
            <Grid item style={{ marginLeft: isDesktop ? '20px' : '0' }}>
              {props.hideNext !== true && (
                <Button
                  endIcon={<NavigateNextIcon />}
                  onClick={payload => props.onClickNext(payload)}
                  disabled={props.nextButtonDisabled}
                >
                  {props.nextButtonText ? (
                    props.nextButtonText
                  ) : props.editMode ? (
                    <>Save</>
                  ) : (
                    <>Next</>
                  )}
                </Button>
              )}
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
      <Toolbar />
    </React.Fragment>
  );
}

StickyNavigation.propTypes = {
  hideBack: PropTypes.bool,
  onClickNext: PropTypes.func.isRequired,
  onClickBack: PropTypes.func,
  nextButtonDisabled: PropTypes.bool,
};
